import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import {
  ISeasonCalendarColour,
  ISeasonCalendarMonth,
  ISeasonCalendarWeek,
  IProposal
} from '@app/activo2/manage-vacations/manage-vacations.interface';

@Component({
  selector: 'app-season-calendar-month',
  templateUrl: './season-calendar-month.component.html',
  styleUrls: []
})
export class SeasonCalendarMonthComponent {
  @Input() month!: ISeasonCalendarMonth;
  @Input() selectedSlots!: BehaviorSubject<IProposal[]>;
  @Input() defaultColours!: ISeasonCalendarColour;

  trackByItems(item: ISeasonCalendarWeek) {
    return item;
  }
}
